import { useState } from 'react';
import useDebounce from '../../hooks/useDebounce';
import { PrettoSlider } from './Slide.component';

function valuetext(value: number) {
  return `${value}`;
}

interface RangeSliderInterface {
  min: number;
  max: number;
  values(e: number[]): void;
}

export default function RangeSlider({ min, max, values }: RangeSliderInterface) {

  const [value, setValue] = useState<number[]>([min, max]);
  const debounce = useDebounce(values, 500);

  const handleChange = (_event: any, newValue: number | number[]) => {
    debounce(newValue as number[])
    setValue(newValue as number[]);
  };

  return (
    <PrettoSlider
      value={value}
      onChange={handleChange}
      valueLabelDisplay="auto"
      aria-labelledby="range-slider"
      getAriaValueText={valuetext}
      min={min}
      max={max}
    />
  );
}